import Image from 'components/shared/image/image';
import RichText from 'components/shared/richtext';
import classNames from 'classnames';
import styles from './programDescription.module.scss';
import VideoPlayer from '../../shared/video/video';
import Button from '../../shared/button/button';

const programDescription = ({ data, locale }) => {
  const customColor = data.backgroundColor?.color;

  return (
    <section
      id="sectionProgramDescription"
      className={styles.description}
      style={{ backgroundColor: customColor }}
    >
      <div
        className={classNames({
          [styles.leftSectionWithImage]: Boolean(data?.image) && !data?.media?.video,
          [styles.leftSectionWithVideo]: data.media.type === 'Video',
        })}
      >
        {data?.media?.type === 'Video' && data?.media?.video ? (
          <VideoPlayer
            className={classNames(styles.video)}
            thumbnail={data?.media?.thumbnail}
            source={data.media.video}
            aspectRatio={data.media.videoAspectRatio}
          />
        ) : (
          <Image
            className={styles.media}
            src={data?.image}
            layout="fill"
            loading="lazy"
            sizes="50vw"
          />
        )}
      </div>
      <div className={styles.rightSection}>
        <h2 className={styles.name}>{data?.subtitle || data?.name}</h2>
        <h3 className={styles.title}>{data?.title}</h3>
        <div
          className={classNames(styles.divider, {
            [styles.darker]: customColor,
          })}
          style={{
            borderColor: customColor,
          }}
        />
        <RichText className={styles.treatmentDescription} text={data?.description?.json} />
        {/* <p>{data?.description}</p> */}
        {data?.button && (
          <div className={styles.buttonContainer}>
            <Button locale={locale} className={styles.button} button={data.button} />
          </div>
        )}
      </div>
    </section>
  );
};

export default programDescription;
